import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { getPolicyBySlug, getRelatedPolicy } from "../Datas/policyData";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";
import "../css/policy.scss";

function PolicyPage() {
  const { policySlug } = useParams();
  const policy = getPolicyBySlug(policySlug);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!policy) return <Navigate to="/legal" replace />;

  const sectionLinks = policy.sections.map((section, index) => ({
    id: `${policy.slug}-${index + 1}`,
    label: section.title,
  }));
  const relatedLinks = policy.related.map(getRelatedPolicy).filter(Boolean);

  return (
    <main className="privacy policy-page">
      <div className="privacy__shell">
        <nav className="privacy__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <Link to="/legal" onClick={toTop}>Legal &amp; policies</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{policy.title}</span>
        </nav>

        <header className="privacy__header">
          <p className="privacy__kicker">Policy information</p>
          <h1>{policy.title}</h1>
          <p className="privacy__updated">Effective 23 October 2026</p>
          <p className="privacy__lede">{policy.summary}</p>
        </header>

        <aside className="privacy__demo" aria-label={`${policy.title} summary`}>
          <span aria-hidden="true">i</span>
          <p><strong>At a glance.</strong> {policy.highlight}</p>
        </aside>

        <div className="privacy__layout">
          <nav className="privacy__contents" aria-label={`${policy.title} contents`}>
            <p>On this page</p>
            <ol>
              {sectionLinks.map(({ id, label }) => (
                <li key={id}><a href={`#${id}`}>{label}</a></li>
              ))}
            </ol>
          </nav>

          <article className="privacy__content">
            {policy.sections.map((section, index) => (
              <section
                id={sectionLinks[index].id}
                className="privacy__section"
                key={section.title}
              >
                <p className="privacy__number">{String(index + 1).padStart(2, "0")}</p>
                <h2>{section.title}</h2>
                {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {section.bullets && (
                  <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>
                )}
              </section>
            ))}

            <section className="privacy__section policy-page__related" aria-labelledby="related-policies-title">
              <p className="privacy__number">{String(policy.sections.length + 1).padStart(2, "0")}</p>
              <h2 id="related-policies-title">Related policies</h2>
              <div className="policy-page__related-links">
                {relatedLinks.map((related) => (
                  <Link key={related.to} to={related.to} onClick={toTop}>
                    {related.label}<span aria-hidden="true">→</span>
                  </Link>
                ))}
              </div>
              <p>
                Questions about this policy can be sent to{" "}
                <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
              </p>
            </section>
          </article>
        </div>
      </div>
    </main>
  );
}

export default PolicyPage;
